import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router';
import { Redirect } from 'react-router-dom';

import RedirectRoute from '../../routes/RedirectRoute';
import CompaniesContainer from '../../containers/CompaniesContainer';

import LicensesTeamContainer from '../../containers/LicensesTeamContainer';

import UpdateProfileContainer from '../../containers/UpdateProfileContainer';

import SupportContainer from '../../containers/SupportContainer';

import MenuComponent from '../core/MenuComponent/MenuComponent';
import { PROFILE_MENU } from '../core/MenuComponent/MenuConstants';
import ScrollToTop from '../../ScrollToTop';
import LoadingComponent from '../core/LoadingComponent/LoadingComponent';
import BreadcrumbsComponent from '../core/BreadcrumbsComponent/BreadcrumbsComponent';

import { LICENSES_PATH, COMPANIES_PATH, UPDATE_PROFILE_PATH, SUPPORT_PATH } from '../../constants/routes';

import './profile.scss';

class ProfileComponent extends React.Component {
    constructor() {
        super();

        this.state = {
            isLoading: true,
        };
    }

    async componentDidMount() {
        const { companies, onCompanySelect } = this.props;

        //select the default company and get members and licenses accordingly
        if (companies && companies[0]) {
            await onCompanySelect(companies[0].firebaseId);
        }

        this.setState({ isLoading: false });
    }

    getMenuItems = (menuItems) => Object.keys(menuItems)
        .filter((keyItem) => {
            const { userRole } = this.props;
            //const { companyRequired, accessDenied } = menuItems[keyItem];
            const { accessDenied } = menuItems[keyItem];

            return (!accessDenied || accessDenied.indexOf(userRole) === -1);
            //return (!companyRequired || isCompanySelected) && (!accessDenied || accessDenied.indexOf(userRole) === -1);
        }).map((keyItem) => ({
            ...menuItems[keyItem],
            url: '/profile/' + keyItem,
            active: this.props.match.params.menuItem === keyItem,
        }))

    render() {
        const {
            // availablePlatform,
            match: { params: matchParams },
        } = this.props;
        // const MEMBER_HOME_PATH = `/api/${PLATFORM_MAP[availablePlatform]}/started`;
        const { menuItem } = matchParams;

        if (!menuItem) {
            return <Redirect to={LICENSES_PATH} />;
        }

        if (this.state.isLoading) {
            return <LoadingComponent fullScreen />;
        }

        return <div id="profile" className="profile-component container">
            <div className="content">
                <div className='sticky-wrapper'>
                    <BreadcrumbsComponent />
                    <MenuComponent
                        menuTitle="Account"
                        menuItems={this.getMenuItems(PROFILE_MENU)}
                    />
                </div>
                <div className="content-wrapper">
                    <ScrollToTop elementId="profile">
                        <Switch>
                            {/* <Route path={LICENSES_PATH} component={LicensesContainer} /> */}
                            {/* {isCompanySelected && <Route path='/profile/license/:action/:id?' component={() =>
                                isUserAdmin ? <LicenseContainer />
                                    : <Redirect to={MEMBER_HOME_PATH} />
                            } />} */}
                            {/* {isCompanySelected && <Route path={TEAM_MEMBERS_PATH} component={() =>
                                isUserAdmin || userRole === MEMBER_ROLES.admin ? <TeamMembersContainer />
                                    : <Redirect to={MEMBER_HOME_PATH} />
                            } />} */}
                            {/* <Route path='/profile/profile' component={() =>
                                <h1>Not Implemented Yet</h1>
                            } /> */}
                            <Route path={LICENSES_PATH} component={LicensesTeamContainer} />
                            <Route path={UPDATE_PROFILE_PATH} component={UpdateProfileContainer} />
                            <Route path={COMPANIES_PATH} component={CompaniesContainer} />
                            <Route path={SUPPORT_PATH} component={SupportContainer} />
                            <RedirectRoute />
                        </Switch>
                    </ScrollToTop>
                </div>
            </div>
        </div>
    }
}

ProfileComponent.propTypes = {
    match: PropTypes.object.isRequired,
    userRole: PropTypes.string,
    // availablePlatform: PropTypes.string,
};

export default ProfileComponent;



// WEBPACK FOOTER //
// ./src/components/profile/ProfileComponent.js